import React from 'react';
import SortButton from './SortButton';
import FilterButton from './FilterButton';
import IconButton from './IconButton';
import PlusIcon from './PlusIcon';

/**
 * Reusable component for displaying tool buttons (sort, filter, add)
 * 
 * @param {Object} props
 * @param {Function} props.onSortClick - Handler for sort button click
 * @param {Function} props.onFilterClick - Handler for filter button click
 * @param {boolean} props.hasActiveFilters - Whether there are active filters
 * @param {Function} props.onAddClick - Optional handler for add button click
 */
const ToolsBar = ({
  onSortClick,
  onFilterClick,
  hasActiveFilters = false,
  onAddClick = null
}) => {
  return (
    <div style={{ 
      display: 'flex', 
      gap: '4px',
      height: '40px',
      alignItems: 'center'
    }}>
      {/* Sort button */}
      <SortButton onClick={onSortClick} />
      
      {/* Filter button */}
      <FilterButton
        onClick={onFilterClick}
        hasActiveFilters={hasActiveFilters}
      />
      
      {/* Add button - Only shows if onAddClick prop is provided */}
      {onAddClick && (
        <IconButton
          onClick={onAddClick}
          icon={<PlusIcon strokeLinecap="butt" strokeLinejoin="miter" />}
          ariaLabel="Add thought"
        />
      )}
    </div>
  );
};

export default ToolsBar; 